import InboxService from '@/services/InboxService';

let interval = null;

const state = {
  buyUnread: 0,
  sellUnread: 0,
  afterServiceUnread: 0,
  inboxTotal: 0,
};

const getters = {
  getBuyUnreadCount: (state) => state.buyUnread,
  getSellUnreadCount: (state) => state.sellUnread,
  getAfterServiceUnreadCount: (state) => state.afterServiceUnread,
  getInboxTotal: (state) => state.inboxTotal,
};

const mutations = {
  setBuyUnreadCount(state, count) {
    state.buyUnread = count;
  },
  setSellUnreadCount(state, count) {
    state.sellUnread = count;
  },
  setAfterServiceUnreadCount(state, count) {
    state.afterServiceUnread = count;
  },
  setInboxTotal(state) {
    state.inboxTotal = state.buyUnread + state.sellUnread + state.afterServiceUnread;
  },
};

const actions = {
  async initInboxSummary({ dispatch }) {
    await dispatch('refreshUnreadCounters');

    if (!interval) {
      interval = setInterval(() => {
        dispatch('refreshUnreadCounters');
      }, 10000);
    }
  },

  async destroyInboxSummary() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  },

  async refreshUnreadCounters({ commit }) {
    try {
      const { buy, sell, after } = await InboxService.getUnreadCounts();

      commit('setBuyUnreadCount', buy);
      commit('setSellUnreadCount', sell);
      commit('setAfterServiceUnreadCount', after);
      commit('setInboxTotal');
    } catch (e) {
      commit('setBuyUnreadCount', 0);
      commit('setSellUnreadCount', 0);
      commit('setAfterServiceUnreadCount', 0);
      commit('setInboxTotal');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
